<script lang="ts">

    import { tweened } from 'svelte/motion';

    export let points: number = 0;

    const tweenedPoints = tweened(0, {
        interpolate: (a, b) => t => Math.floor(a + ((b - a) * t)),
    });

    $: $tweenedPoints = points;

</script>

<style lang="scss">

    .points {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        color: #fff;
        font-family: var(--font-londrina);
        font-size: 1.6rem;
    }

    img {
        $size: 1.5rem;
        width: $size;
        height: $size;
    }

</style>

<div class="points">
    <img src="images/trophy.svg" alt="#"> {$tweenedPoints} pts
</div>
